import { useCallback, useMemo, useRef } from 'react';

export const useSwiper = (initialSlide, slides, breakpoints, setNavigate) => {
    const swiperRef = useRef(null);

    const handlePrev = useCallback(() => {
        swiperRef.current?.swiper.slidePrev();
    }, [swiperRef]);

    const handleNext = useCallback(() => {
        swiperRef.current?.swiper.slideNext();
    }, [swiperRef]);

    const swiperBreakpoints = useMemo(
        () => {
            const slidesCount = slides.length;

            return Object.entries(breakpoints).reduce((res, [key, breakpoint]) => {
                const slidesPerView = breakpoint.slidesPerView
                    ? breakpoint.slidesPerView <= slidesCount
                        ? breakpoint.slidesPerView
                        : slidesCount
                    : null;

                res[key] = {
                    ...breakpoint,
                    slidesPerView,
                };

                return res;
            }, {});
        },
        slides,
        breakpoints
    );

    const handleSetNavigate = useCallback((swiper) => setNavigate({ realIndex: swiper.realIndex, isEnd: swiper.isEnd }), []);

    const handleResize = useCallback(
        (swiper) => {
            handleSetNavigate(swiper);
            swiper.slideTo(initialSlide);
        },
        [initialSlide]
    );

    return {
        swiperRef,
        swiperBreakpoints,
        handlePrev,
        handleNext,
        handleResize,
        handleSetNavigate,
    };
};
